module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/HowToForeground-9429ce9bcb7dd73aea3df521c229370c.png";